import { render, staticRenderFns } from "./wanchengduPieChart.vue?vue&type=template&id=c2347ea6"
import script from "./wanchengduPieChart.vue?vue&type=script&lang=js"
export * from "./wanchengduPieChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports